////////////////
//    APIS    //
////////////////

// Timeline

export const pathApiPostsTimeline = '/v2/posts/timeline'
export const pathApiPostsPublicTimeline = '/v1/web/posts/public_timeline'
export const pathApiPostsNoReplyTimeline = '/v2/posts/noreply_timeline'
export const pathApiPostsFollowingTimeline = '/v2/posts/following_timeline'
export const pathApiPostsGroupTimeline = '/v2/posts/group_timeline'
export const pathApiPostsUserTimeline = '/v2/posts/user_timeline'
export const pathApiPostsRecommendedTimeline = '/v2/posts/recommended_timeline'
export const pathApiPostsTags = ({ hashtag }) => `/v2/posts/tags/${hashtag}`
export const pathApiPostsSearch = '/v2/posts/search'
export const pathApiGroupPostsSearch = ({ groupId }) =>
  `v2/groups/${groupId}/posts/search`

// Posts

export const pathApiPostsNew = '/api/posts'
export const pathApiPostsRepost = '/v3/posts/repost'
export const pathApiPostsShowV2 = ({ postId }) => `/v2/posts/${postId}`
export const pathApiPostsShow = ({ postId }) => `/v3/posts/${postId}`
export const pathApiPostsLike = '/v2/posts/like'
export const pathApiPostsUnlike = ({ postId }) => `/v1/posts/${postId}/unlike`
export const pathApiPostsPinnedPost = '/v1/pinned/posts'
export const pathApiPostsPinnedPostShow = ({ postId }) =>
  `/v1/pinned/posts/${postId}`
export const pathApiPostsGroupPinnedPost = '/v2/posts/group_pinned_post'
export const pathApiPostsLikers = ({ postId }) => `/v1/posts/${postId}/likers`
export const pathApiPostsReposts = ({ postId }) => `/v2/posts/${postId}/reposts`
export const pathApiPostsNewSharePost = '/v1/posts/new_share_post'
export const pathApiPostsMoveToThread = ({ postId }) =>
  `/v3/posts/${postId}/move_to_thread`
export const pathApiPostsMoveToThreadShow = ({ postId, threadId }) =>
  `/v3/posts/${postId}/move_to_thread/${threadId}`

export const pathApiPostsUrlMetadata = '/v2/posts/url_metadata'
export const pathApiPostsActiveCall = '/v1/posts/active_call'
export const pathApiPostsNewConferenceCall = '/v1/web/posts/new_conference_call'
export const pathApiPostsValidate = '/v1/posts/validate'

export const pathApiRecommendedRespond = ({ postId }) =>
  `/v2/posts/${postId}/recommendation_feedback`

// Gifts

export const pathApiGiftsList = '/v2/gifts'
export const pathApiGiftInventory = '/v2/received_gifts'
export const pathApiGiftsReceivedUser = ({ userId }) =>
  `/v1/users/${userId}/gift_transactions`
export const pathApiGiftsReceivedPost = ({ postId }) =>
  `/v1/posts/${postId}/gift_transactions`
export const pathApiGiftsReceivedGroup = ({ groupId }) =>
  `/v1/groups/${groupId}/gift_transactions`
export const pathApiGiftsReceivedCall = ({ callId }) =>
  `/v1/calls/${callId}/gift_transactions`
export const pathApiSendGiftUser = ({ userId }) =>
  `/v1/users/${userId}/gift_transactions`
export const pathApiSendGiftPost = ({ postId }) =>
  `/v1/posts/${postId}/gift_transactions`
export const pathApiSendGiftGroup = ({ groupId }) =>
  `/v1/groups/${groupId}/gift_transactions`
export const pathApiSendGiftCall = ({ callId }) =>
  `/v1/calls/${callId}/gift_transactions`
export const pathApiGetExchangeGiftRewards = `/v1/gift_rewards`
export const pathApiExchangeGiftRewards = ({ giftComboId }) =>
  `/v1/gift_rewards/${giftComboId}`
export const pathApiReceivedGiftTransactionDetails = ({
  giftTransactionUuid,
}) => `/v1/received_gifts/${giftTransactionUuid}`
export const pathApiGiftExchangeTransactionHistory = `/v1/gift_exchange_histories`
export const pathApiGiftExchangeTransactionDetails = ({
  giftTransactionUuid,
}) => `/v1/gift_exchange_histories/${giftTransactionUuid}`

// Survey

export const pathApiSurveysVote = ({ surveyId }) =>
  `/v2/surveys/${surveyId}/vote`

// Conversations

export const pathApiConversations = ({ conversationId }) =>
  `/v2/conversations/${conversationId}`
export const pathApiConversationsRootPosts = '/v2/conversations/root_posts'

// Groups

export const pathApiGroupsNew = '/api/groups'
export const pathApiGroupsEdit = ({ groupId }) => `/api/groups/${groupId}`
export const pathApiGroupsShow = ({ groupId }) => `/v1/groups/${groupId}`
export const pathApiGroupsVisit = ({ groupId }) => `/v1/groups/${groupId}/visit`

export const pathApiGroupsFire = ({ groupId, userId }) =>
  `/v1/groups/${groupId}/fire/${userId}`

export const pathApiGroupsJoinedStatuses = '/v1/groups/joined_statuses'
export const pathApiGroupsShowRequestWalkthrough = ({ groupId }) =>
  `/v1/groups/${groupId}/request_walkthrough`

// Threads

export const pathApiThreads = '/v1/threads'
export const pathApiThreadsShow = ({ threadId }) => `/v1/threads/${threadId}`
export const pathApiThreadsPosts = ({ threadId }) =>
  `/v1/threads/${threadId}/posts`

export const pathSelfApiThreadsPosts = ({ threadId }) =>
  `/api/threads/${threadId}/posts`

export const pathApiThreadsShowMembersShow = ({ threadId, userId }) =>
  `/v1/threads/${threadId}/members/${userId}`

export const pathApiThreadsJoinedStatuses = '/v1/threads/joined_statuses'

// Highlights

export const pathApiHighlights = ({ groupId }) =>
  `/v1/groups/${groupId}/highlights`
export const pathApiHighlight = ({ groupId, id }) =>
  `${pathApiHighlights({ groupId })}/${id}`

// Games

export const pathApiGames = '/v1/games'
export const pathApiGamesApps = `${pathApiGames}/apps`
export const pathApiWalkthroughs = ({ appId }) =>
  `${pathApiGames}/apps/${appId}/walkthroughs`

// Bookmarks

export const pathApiBookmarks = ({ userId }) => `/v1/users/${userId}/bookmarks`
export const pathApiBookmark = ({ userId, id }) =>
  `${pathApiBookmarks({ userId })}/${id}`

// Users

export const pathApiUsersChangeEmail = '/v1/users/change_email'
export const pathApiUsersEmailVerificationUrls = '/v1/email_verification_urls'
export const pathApiUsersEmailGrantTokens = `apis/v1/apps/${process.env.IDCARDCHECK_API_APP_NAME}/email_grant_tokens`

export const pathApiUsersLoginUpdate = '/v3/users/login_update'
export const pathApiUsersResetPassword = '/v1/users/reset_password'

export const pathApiUsersShow = ({ userId }) => `/v2/users/${userId}`
export const pathApiUsersEditV3 = '/v3/users/edit'

export const pathApiUsersReviewsShow = ({ userId }) =>
  `/v1/users/reviews/${userId}`

export const pathApiUsersFootprints = '/v2/users/footprints'
export const pathApiUsersFootprintsShow = ({ userId, footprintId }) =>
  `/v2/users/${userId}/footprints/${footprintId}`

export const pathApiUsersBlock = ({ userId }) => `/v1/users/${userId}/block`
export const pathApiUsersUnblock = ({ userId }) => `/v2/users/${userId}/unblock`

export const pathApiUsersGetCustomDefinitions = '/v1/users/custom_definitions'
export const pathApiUsersRemoveProfilePhoto = '/v2/users/remove_profile_photo'
export const pathApiUsersRemoveCoverImage = '/v2/users/remove_cover_image'
export const pathApiUsersInterests = '/v1/users/interests'

export const pathApiUsersDiscover = '/v1/web/users/discover'
export const pathApiUsersHimaUsers = '/v1/web/users/hima_users'
export const pathApiUsersHima = '/v1/users/hima'
export const pathApiUsersRecent = '/v1/users/recent'
export const pathApiUsersSearch = '/v1/web/users/search'
export const pathApiUsersVipUsers = '/v1/users/vip_users'
export const pathApiUsersForgotPassword = '/v2/users/forgot_password'
export const pathSelfApiUsersLanguage = '/api/users/language'
export const pathApiUsersFollowRequestsCount = '/v2/users/follow_requests_count'
export const pathApiUsersActiveFollowings = '/v1/users/active_followings'
export const pathApiUsersFollowRecommended = ({ userId }) =>
  `/v1/users/${userId}/follow_recommended`

export const pathApiUsersWebFollowers = ({ userId }) =>
  `/v2/users/${userId}/web_followers`
export const pathApiUsersFollowers = ({ userId }) =>
  `/v2/users/${userId}/followers`

export const pathApiUsersPolicyAgreement = '/v1/users/policy_agreements'
export const pathApiUsersPolicyAgreementTerms =
  '/v1/users/policy_agreements/terms_of_use'
export const pathApiUsersPolicyAgreementPrivacy =
  '/v1/users/policy_agreements/privacy_policy'
export const pathApiUsersPolicyAgreementEmpl =
  '/v1/users/policy_agreements/empl_2'

export const pathApiUsersDeviceTokensNew = '/v1/web/users/device_tokens/new'
export const pathApiUsersAlive = '/v1/users/alive'
export const pathApiUsersDefaultSettings = '/v1/users/default_settings'

export const pathApiUsersSecret = '/v1/users/secret'
export const pathApiUsersSecretEnable = '/v1/users/secret/enable'
export const pathApiUsersSecretDisable = '/v1/users/secret/disable'

// Reports

export const pathApiUsersReport = ({ userId }) => `/v3/users/${userId}/report`
export const pathApiChatRoomsReport = ({ chatRoomId }) =>
  `/v3/chat_rooms/${chatRoomId}/report`
export const pathApiPostsReport = ({ postId }) => `/v3/posts/${postId}/report`
export const pathApiGroupsReport = ({ groupId }) =>
  `/v3/groups/${groupId}/report`

// Chats

export const pathApiChatRoomsMainList = '/v1/chat_rooms/main_list'
export const pathApiChatRoomsRequestList = '/v1/chat_rooms/request_list'
export const pathApiChatableFollowing = '/v1/users/followings/chatable'

export const pathApiChatRoomsTotalChatRequest =
  '/v1/chat_rooms/total_chat_request'

export const pathApiChatRoomsAcceptChatRequest =
  '/v1/chat_rooms/accept_chat_request'

export const pathApiChatRoomsMassDestroy = '/v1/chat_rooms/mass_destroy'

export const pathApiChatRoomsPinned = ({ chatId }) =>
  `/v1/chat_rooms/${chatId}/pinned`

export const pathApiChatSingleRecipientNew = '/v1/chat_rooms/new'
export const pathApiChatRoomsNew = '/v3/chat_rooms/new'
export const pathApiChatRoomsFindRoom = ({ userId }) =>
  `/v1/chat_rooms/find_room/?user_id=${userId}`

export const pathApiChatRoomsShow = ({ chatId }) => `/v2/chat_rooms/${chatId}`

export const pathApiChatRoomsMessages = ({ chatId }) =>
  `/v2/chat_rooms/${chatId}/messages`

export const pathApiChatRoomsMessagesNew = ({ chatId }) =>
  `/v3/chat_rooms/${chatId}/messages/new`

export const pathApiChatRoomsMessagesDelete = ({ chatId, messageId }) =>
  `/v1/chat_rooms/${chatId}/messages/${messageId}/delete`

export const pathApiChatRoomsMessagesRead = ({ chatId, messageId }) =>
  `/v2/chat_rooms/${chatId}/messages/${messageId}/read`
export const pathApiChatRoomsAttachmentsRead = ({ chatId }) =>
  `/v1/chat_rooms/${chatId}/attachments_read`
export const pathApiChatRoomsVideosRead = ({ chatId }) =>
  `/v1/chat_rooms/${chatId}/videos_read`

// Activity a.k.a. Notification
export const pathActivities = '/api/user_activities'
export const pathActivitiesSingleFeed = '/api/v2/user_activities'

// Anonymous calls

export const pathApiAnonymousCalls = '/v1/anonymous_calls'

// Tools

export const pathApiToolsPostsTimeline = '/tools/posts/timeline'
export const pathApiFeedbacks = '/tools/feedbacks'

// Miscellaneous

export const pathApiStickerPacks = '/v2/sticker_packs'
export const pathApiUsersGifData = '/v1/users/gif_data'
export const pathApiUsersRanking = '/v1/web/users/ranking'

export const pathApiPresignedTestnetAirdrop =
  '/v1/presigned/wallet/claims/create'
export const pathApiPresignedWalletBagCreate =
  '/v2/presigned/wallet/bags/create'
export const pathApiPresignedWalletBagShow = '/v2/presigned/wallet/bags/show'
export const pathApiPresignedWalletShow = '/v2/presigned/wallet/wallets/show'
export const pathApiPresignedWalletLink = '/v2/presigned/wallet/wallets/create'
export const pathApiPresignedWalletUnlink =
  '/v2/presigned/wallet/wallets/delete'
export const pathApiPresignedWalletCurrency = '/v1/presigned/wallet/currency'
export const pathApiPresignedWalletEmplTransactions =
  '/v1/presigned/wallet/empl_transactions'
export const pathApiPresignedWalletEmplTransactionDetails =
  '/v1/presigned/wallet/empl_transactions/show'
export const pathApiPresignedWalletTransactionDetails =
  '/v2/presigned/wallet/transactions/show'
export const pathApiExpiringEmplTransactions =
  '/v1/wallet/empl_transactions/expirings'
export const pathApiPresignedWalletExpiringEmplTransactions =
  '/v1/presigned/wallet/empl_transactions/expiring_list'
export const pathApiDotMoneyCallbackUrl = '/v1/wallet/dotmoney/login_url'

export const pathApiOneTimePassword = '/v1/one_time_password'

////////////////////
//    SETTINGS    //
////////////////////

export const pathSettingsAppsPopularWords = '/apps/yay/popular_words'
export const pathSettingsBannedWords = '/v2/banned_words'
